type SearchParams = string[][] | Record<string, string> | string

export const getURLParams = (urls: string[], params?: SearchParams): string => {
  const urlParams = new URLSearchParams(params)
  const urlLink = urls.join('/')

  return urlParams.size ? `${urlLink}?${urlParams.toString()}` : urlLink
}
